import { useEffect } from 'react';
import { Box } from '@mui/material';
import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import txLogo from '../../../assets/tx-logo.png';

const TexasPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'RSS - Texas Orders';
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = txLogo;
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100dvh',
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        backgroundImage: {
          md: 'linear-gradient(90deg, var(--tx-primary) 0%, var(--tx-secondary) 100%)',
          xs: 'linear-gradient(180deg, var(--tx-primary) 0%, var(--tx-secondary) 100%)',
        },
      }}
    >
      <Box
        component={Link}
        to='/tx'
        sx={{
          display: 'inline-flex',
          width: {
            xs: 140, // mobile
            sm: 180,
            md: 200,
          },
          height: 'auto',
        }}
      >
        <Box
          component='img'
          src={txLogo}
          alt={t('alt.texas_lottery_logo')}
          sx={{
            display: 'block',
            width: '100%',
            height: 'auto',
          }}
        />
      </Box>

      <Outlet />
    </Box>
  );
};

export default TexasPage;
